export const pathnameStaticPage = ['/', '/quick-start', '/tech-solution', '/developer-docs']
